<glxy-form-field>
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_FREE_TRIAL_CANCELLATION_REASON' | translate }}
  </glxy-label>
  <mat-select [(value)]="cancelReason">
    <mat-option value="*">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PARTNER_SUBSCRIPTION_TIER_UPDATE' | translate }}
    </mat-option>
    <mat-option *ngFor="let reason of cancelReasonOptions" [value]="reason.value">
      {{ reason.i18nKey | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
